import React from 'react';
import { EventList } from './view/eventList';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'EventList', 
  itemElt: (item, cmsOption) => <EventList item={item} cmsOption={cmsOption} />
}



